import * as t from 'io-ts';
import { fromEnum } from '../../responseUtil';
import { MeansOfTransportTypeCodec } from '../meansOfTransportType.types';

export enum ApiModeOfTransport {
    ROAD_TRANSPORT = 'road-transport',
    MARITIME_TRANSPORT = 'maritime-transport',
    RAIL_TRANSPORT = 'rail-transport',
}

export const ModeOfTransportCodec = fromEnum<ApiModeOfTransport>('ApiModeOfTransport', ApiModeOfTransport);

export const MeansOfTransportCodec = t.intersection([
    t.type({
        type: MeansOfTransportTypeCodec,
    }),
    t.partial({
        id: t.string,
        asset_id: t.string,
        trailer_id: t.string,
    }),
]);

export type ApiMeansOfTransport = t.TypeOf<typeof MeansOfTransportCodec>;
